import { render, staticRenderFns } from "./Catgoryitems.vue?vue&type=template&id=4be324bd&"
import script from "./Catgoryitems.vue?vue&type=script&lang=js&"
export * from "./Catgoryitems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports